import { useEffect, useState } from 'react';
import icEye from '../../assets/svg/iconamoon_eye.svg'
import icSignUp from '../../assets/svg/auth/plus.svg'
import icPasswprd from '../../assets/svg/auth/ic-eye-password.svg'
import arrowDown from '../../assets/svg/arrow-down.svg';
import icCard from '../../assets/svg/auth/sign-up.svg'
import 'react-phone-number-input/style.css';
import PhoneInput, { getCountries } from 'react-phone-number-input';
import 'react-phone-input-2/lib/style.css'
import axiosClient from '../../../axios-client.js';
import { useStateContext } from '../../context/ContextProvider.jsx';
import { ToastContainer, toast } from 'react-toastify';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Helmet } from 'react-helmet';

const SignUp = () => {
  const [ fullName, setFullName ] = useState('')
  const [ userName, setuserName ] = useState('')
  const [ email, setEmail ] = useState('')
  const [ phoneNumber, setPhone ] = useState('')
  const [ password, setPassword ] = useState('')
  const [ rePassword, setRePassword ] = useState('');
  const [ showPassword, setShowPassword ] = useState(false);
  const [ showRePassword, setShowRePassword ] = useState(false);
  const [ msgtError, setMsgError ] = useState();
  const { setUser, setToken } = useStateContext()
  const [ errors, setErrors ] = useState(null)
  const [ countryCode, setCountryCode ] = useState('MA')
  const [ isValid, setIsValid ] = useState(false);
  const [ isValidion, setIsValidion ] = useState(false);
  const [ metTitle, setMetaTitle ] = useState('');
  const [ metaDescription, setMetaDescription ] = useState('');


  useEffect(() => {
    appSettings();
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
    setShowRePassword(!showPassword);
    clearErrors();
  };


  const supportedCountries = getCountries().filter((code) => code !== 'EH');

  const errNotify = ({ msgErr }) => {
    toast.error(`${msgErr}`, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };


  const clearErrors = () => {
    setMsgError('');
    setErrors(null);
  };

  const onSubmit = ev => {
    ev.preventDefault()
    clearErrors();

    const payload = {
      email: email,
      country_code: countryCode,
      phone: phoneNumber,
      name: fullName,
      username: userName,
      password: password,
      c_password: rePassword,
    }

    axiosClient.post('/register?', payload)
      .then(({ data }) =>
      {
        setUser(data.data.user)
        setToken(data.data.token);
        window.location.href = '/new-message';
      })
      .catch(err =>
      {
        const response = err.response.data;
        if (response) {
          const errorMessages = Object.values(response)
            .map((errorArray) => errorArray[ 0 ]);
          setMsgError(errorMessages);
          setErrors(response);
        } else {
          console.error('Unexpected error response format:', response);
        }
      })
  }


  const appSettings = () => {
    axiosClient.get('/app-settings')
      .then(({ data }) =>
      {
        setMetaTitle(data.data.title)
        setMetaDescription(data.data.description);
      })
      .catch(() =>
      {
        setLoading(false)
      })
  }

  const onchangeNumber = (val) => {
    setPhone(val);
    if (val) {
      const parsedPhoneNumber = parsePhoneNumberFromString(val, countryCode);
      setIsValid(parsedPhoneNumber ? parsedPhoneNumber.isValid() : false);
      // setIsValidion(true)
      console.log(isValidion)

    }
  };

  const handlePhoneChange = (value, selectedCountry) => {
    setCountry(selectedCountry);
  };


  return (
    <>
      <Helmet>
        <title>Sign up | { metTitle }</title>
        <meta name="description" content={ metaDescription } />
        <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
      </Helmet>
      <div className='container my-5'>
        <ToastContainer />
        <div className='row justify-content-center align-items-center'>
          <div className='col-md-6 my-5 px-1'>
            <div className='card bg-white border justify-content-center align-items-center'>
              <img width={ 52 } height={ 52 } className='ic-card mx-auto' src={ icCard } />
              <h1 className='text-center title my-3'>Sign up</h1>
              <div className='divider my-4'></div>
              <form onSubmit={ onSubmit } className='text-start py-3 col-md-8'>
                <div className='form-group py-1'>
                  <label className='mb-1' htmlFor='fullName'>Full Name</label>
                  <input
                    required
                    className='form-control rounded-pill'
                    placeholder='Full Name'
                    value={ fullName }
                    onChange={ (e) => setFullName(e.target.value) }
                  />
                </div>
                <div className='form-group py-1 mt-4'>
                  <label className='mb-1' htmlFor='username'>Email Address</label>
                  <input
                    required
                    className='form-control rounded-pill'
                    placeholder='Email'
                    value={ email }
                    onChange={ (e) => setEmail(e.target.value) }
                    onClick={ clearErrors }
                  />
                </div>
                <div className='form-group py-1 mt-4'>
                  <label className='mb-1' htmlFor='username'>Your WhatsApp number</label>

                  <div className={ `${isValid ? 'border-success' : ''} d-flex form-control rounded-pill justify-content-start align-items-center` }>
                    <img width={ 18 } className='arrow-phone' src={ arrowDown } />
                    <PhoneInput
                      onClick={ clearErrors }
                      id={ 'phoneId' }
                      countries={ supportedCountries }
                      className='form-control border-0 bg-transparent rounded-pill'
                      placeholder='669 47 00 00'
                      international
                      defaultCountry='MA'
                      country="MA"
                      value={ phoneNumber }
                      onCountryChange={ (c) => setCountryCode(c) }
                      onChange={ (val) => onchangeNumber(val) }
                      // onChange={(value, country, e, formattedValue) => {
                      //   clearErrors();
                      //   setPhone(value);

                      // }}
                      countrySelectProps={ {
                        unicodeFlags: true
                      } }
                      countryCallingCodeEditable={ true }
                    />
                  </div>
                  {/* <PhoneInput
                    className='form-control border-0 bg-transparent rounded-pill'
                    required
                    enableAreaCodes={true}
                    enableSearch={true}
                    inputProps={{
                      name: 'phoneNumber', // Set the name attribute if needed
                    }}
                    country={'ma'}
                    specialLabel=''
                    value={phoneNumber}
                    onChange={(value, country, e, formattedValue) => {
                      setPhone(value);
                    }}
                    countryCallingCodeEditable={false}
                  /> */}
                </div>
                <div className='form-group py-1 mt-4'>
                  <label className='mb-1' htmlFor='password'>
                    Password
                  </label>
                  <div className='password-input d-flex justify-content-center align-items-center' >
                    <input
                      onClick={ clearErrors }
                      required
                      className='password-input form-control rounded-pill'
                      type={ showPassword ? 'text' : 'password' }
                      value={ password }
                      placeholder='Password'
                      onChange={ (e) => setPassword(e.target.value) }
                    />
                    <span className='ic-shor-password toggle-password-visibility'
                      onClick={ togglePasswordVisibility }>
                      <img width={ 24 } height={ 24 } className='ic-ey' src={ showPassword ? icPasswprd : icEye } />
                    </span>
                  </div>
                </div>
                <div className='form-group py-1 mt-4'>
                  <label className='mb-1' htmlFor='password'>
                    Retype new Password
                  </label>
                  <div className='password-input d-flex justify-content-center align-items-center' >
                    <input
                      required
                      className='password-input form-control rounded-pill'
                      type={ showRePassword ? 'text' : 'password' }
                      value={ rePassword }
                      placeholder='Password'
                      onClick={ clearErrors }
                      onChange={ (e) => setRePassword(e.target.value) }
                    />
                    <span className='ic-shor-password toggle-password-visibility'
                      onClick={ togglePasswordVisibility }>
                      <img width={ 24 } height={ 24 } className='ic-ey' src={ showRePassword ? icPasswprd : icEye } />
                    </span>
                  </div>
                </div>

                <div className={ `${!msgtError ? 'd-none' : 'd-block'} alert alert-danger my-2` } role="alert">
                  <ul>
                    { msgtError && msgtError.map((error, index) => (
                      <li key={ index }>{ error }</li>
                    )) }
                  </ul>

                </div>
                {/* <div className={`${!isValidion ? 'd-block' : 'd-none'} alert alert-danger mt-2 mb-2`} role="alert">Please enter a valid Whatsapp phone number !</div> */ }
                <div className='d-flex'>
                  <input className='btn-login my-4 px-5 rounded-pill' type='submit' value='Create your account' />
                  <img width={ 38 } height={ 38 } className='ic-eye' src={ icSignUp } />
                </div>
              </form>

              <div className='my-5 d-flex'>
                <p className='fw-bolder txt-gray'>Already have an account ?</p>
                <a className='fw-bolder mx-2' href='/login'>Sign in</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignUp;